export default __webpack_public_path__ + "static/media/I12.66d03b5b.jpg";